import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import ApplyForm from "~/Components/Elements/Forms/Apply/ApplyForm";
import { useUser } from "~/Context/userContext";

const ApplyPage = () => {
  const { state: userState, dispatch } = useUser();
  const [saved, setSaved] = useState(false);
  const [failure, setFailure] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [openAppForm, setOpenAppForm] = useState(false);
  const onFailure = (message) => {
    setFailure(true);
    setFailureMessage(message || "");
  };
  const onSave = () => {
    setSaved(true);
    setFailure(false);
    setFailureMessage("");
  };

  if (!userState.loaded) {
    return null;
  }

  const isChim = userState && userState.loggedin && userState.isChim;

  if (!isChim) {
    return (
      <div className="ApplyPageWrapper">
        <div className="page-header">
          <h2>Become A Chimney</h2>
          <p>
            Fill out this short list of questions so we can get to know you and your musical tastes. Once you are approved you will be able
            to post your favorite track each day, comment, add a profile, save favorites and more.
            {!userState.loggedin && (
              <span>
                {` `}To create a basic Dream Chimney account{" "}
                <a href="javascript:;" onClick={() => dispatch({ type: "signin_open" })}>
                  register here
                </a>
                .
              </span>
            )}
          </p>
          {saved && <p style={{ fontWeight: "bold", marginTop: "40px" }}>Thank you. We will review your membership details and reply ASAP.</p>}
          {failure && !saved && (
            <Alert variant="danger">
              {failureMessage === "Invalid Application" ? (
                "Your application looks incomplete. Please add a fuller reason to become a Chimney (at least a few words) and try again."
              ) : (
                <>
                  {failureMessage || "There was an error while saving. Please check your answers one more time"} and try again or contact{" "}
                  <Link to={`/profile/ryan`}>Ryan Chimney</Link> with your details.
                </>
              )}
            </Alert>
          )}

          {!saved && <ApplyForm onFailure={onFailure} onComplete={onSave} />}
        </div>
      </div>
    );
  }

  return (
    <Redirect
      to={{
        pathname: "/",
        state: {},
      }}
    />
  );
};

export default ApplyPage;
